import React, { Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';
import routes from './routes/routes';
import ArrowLoader from './components/ArrowLoader';

const AppRoutes = () => (
    <Suspense fallback={<ArrowLoader arrowStyles={{ position: 'absolute', top: '50%', left: '48%' }} />}>
        <Switch>
            {routes.map((route) => (
                <Route key={route.path} path={route.path} exact={route.exact} component={route.component} />
            ))}
        </Switch>
    </Suspense>
);

export default AppRoutes;
